<template>
    <FormSection title="Clinical Information" :full-height="false" :application-id="referral.application">
        <template #content>
            <section class="row px-4 my-2">
                <section class="col-12">
                    <div class="d-flex">
                        <div class="form-group col-12 col-lg-6 pe-lg-2">
                            <label for="patient-first-name">
                                Referring {{ isApplicationPalliative ? "Provider" : "Physician" }}
                            </label>
                            <TypeaheadInput
                                :getData="getPhysicianList"
                                :value="attendingPhysician"
                                v-on:valueChanged="attendingPhysicianChanged"
                                placeholder="Start Typing..."
                            >
                            </TypeaheadInput>
                        </div>
                        <div class="form-group col-12 col-lg-6">
                            <label for="patient-middle-initial"> Care Team </label>
                            <select class="form-select" v-model="referral.careTeamId">
                                <option :value="null">Select Care Team</option>
                                <option v-for="team of teams" :key="team.id" :value="team.id">{{ team.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div
                        class="form-group col-12 col-lg-6"
                        v-if="showPreAdmissionEvaluation && !isApplicationPalliative"
                    >
                        <div class="form-check custom-checkbox form-check-inline">
                            <input
                                type="checkbox"
                                id="referral-is-pre-admn-req"
                                class="form-check-input au-target"
                                v-model="referral.isPreadmissionRequired"
                            />
                            <label class="form-check-label" for="referral-is-pre-admn-req">
                                <span class="me-1">Pre-Admission Evaluation</span>
                            </label>
                        </div>
                    </div>
                    <section class="col-12 row g-0">
                        <div class="form-group col-12 col-lg-6 pe-lg-2" v-show="referral.isPreadmissionRequired">
                            <label for="patient-middle-initial"> Assign to </label>
                            <TypeaheadInput
                                :getData="usersFetch"
                                :value="selectedUser"
                                v-on:valueChanged="selectedUserChanged"
                                placeholder="Start Typing..."
                            ></TypeaheadInput>
                        </div>
                        <div class="form-group col-12 col-lg-6" v-show="referral.isPreadmissionRequired">
                            <label for="patient-middle-initial"> Evaluation Date </label>
                            <DatePicker :getDate="handleDateChange">
                                <div class="input-group date datepickerInput">
                                    <input
                                        name="preadmissionEvaluationDate"
                                        type="text"
                                        class="form-control"
                                        placeholder="MM/DD/YYYY"
                                        :value="formatDateInput(referral.preadmissionEvaluationDate)"
                                        @change="(e: any) => handleDateChange(e.target.value, e.target.name)"
                                        autocomplete="off"
                                        date-format-only
                                    />
                                    <div class="input-group-addon input-group-append">
                                        <div class="input-group-text">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                    </div>
                                </div>
                            </DatePicker>
                        </div>
                    </section>
                    <section class="col-12 row g-0">
                        <div class="form-group col-12 col-lg-6 pe-lg-2">
                            <label for="patient-middle-initial"> Referral Diagnosis </label>
                            <Diagnosis
                                :selected-diagnosis="referralDiagnosis"
                                classes="d-inline-block w-100"
                                :diagnosis-changed="referralDiagnosisChanged"
                                :application="referral.application"
                            ></Diagnosis>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="tolerable-pain-level"> Tolerable Pain Level</label>
                            <select
                                name="tolerable-pain-level"
                                class="form-select"
                                v-model="referral.tolerablePainLevel"
                            >
                                <option :value="null">Select Tolerable Pain Level</option>
                                <option
                                    v-for="[key, value] of enumToMap(TolerablePainLevels)"
                                    :key="key"
                                    :value="value.value"
                                >
                                    {{ value.value }} - {{ value.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-lg-12">
                            <DiagnosisTable
                                :diagnosis="referral.diagnoses"
                                :updateDiagnosis="updateDiagnosis"
                                :referral="referral"
                                :id="referral.id"
                            />
                        </div>
                    </section>
                </section>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./ClinicianInformation.ts"></script>
